import { useCallback } from 'react';
import analytics from '@mediashop/app/analytics';
import { Product, Variant } from '../../api/types/ClientProduct';
import { useShopContext } from '../../hooks/useShopContext';
import { useCategories } from '../../queries/categories/useCategories';

type HookReturnTypeParams = {
    product: Product;
    variant?: Variant;
};

type HookReturnType = (params: HookReturnTypeParams) => void;

/**
 * Hook that handles analytics events for a single products details
 * @returns A function that can be used to trigger the analytics event
 */
export const useProductDetailsAnalytics = (): HookReturnType => {
    const { country } = useShopContext();
    const { data: categories = [] } = useCategories();
    const mainCategory = categories[0];

    const dispatchProductDetails = useCallback(
        ({ product, variant }) => analytics.dispatchProductDetails({ product, variant, mainCategory, country }),
        [country, mainCategory]
    );

    return dispatchProductDetails;
};
